<template>
  <div>
    <div id="content" class="content" style="margin-left:0px;">
      <h1 class="page-header" style="text-align:left">
        出库管理&nbsp;<small>/&nbsp;<router-link to="/outbound" class="TitleStyle">出库单管理列表&nbsp;</router-link>/&nbsp;出库单详情</small>
      </h1>
      <div
        id="page-container"
        class="in page-sidebar-fixed page-header-fixed"
        style="padding-top:0px;"
      >
        <!-- begin #content -->
        <div
          id="content"
          class="content"
          style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
        >
          <!-- begin breadcrumb -->

          <div class="row">
            <!-- begin col-10 -->
            <div class="col-lg-12">
              <!-- begin panel -->
              <div class="panel panel-inverse">
                <!-- begin panel-heading -->
                <div class="panel-heading">
                  <div class="panel-heading-btn">
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-default"
                      data-click="panel-expand"
                    >
                      <i class="fa fa-expand"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-success"
                      data-click="panel-reload"
                    >
                      <i class="fa fa-redo"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-warning"
                      data-click="panel-collapse"
                    >
                      <i class="fa fa-minus"></i>
                    </a>
                    <a
                      href="javascript:;"
                      class="btn btn-xs btn-icon btn-circle btn-danger"
                      data-click="panel-remove"
                    >
                      <i class="fa fa-times"></i>
                    </a>
                  </div>
                  <h4 class="panel-title panelTitle">采购单详情</h4>
                </div>
                <!-- end panel-heading -->
                <!-- begin panel-body -->
                <div class="panel-body">
                  <form style="margin-top:16px;">
                    <fieldset>
                      <div class="form-group row m-b-15">
                        <label class="col-md-1 col-form-label">品牌名称</label>
                        <div class="col-md-2">
                          <v-selectpage
                            :data="BrandOptions"
                            key-field="brandId"
                            show-field="brandName"
                            placeholder="品牌名称"
                            v-model="brandId"
                            @values="BrandChange"
                            title=""
                          ></v-selectpage>
                        </div>
                        <label class="col-md-1 col-form-label">系列名称</label>
                        <div class="col-md-2">
                          <v-selectpage
                            :data="SeriesOptions"
                            key-field="seriesId"
                            show-field="seriesName"
                            placeholder="系列名称"
                            v-model="seriesId"
                            title=""
                          ></v-selectpage>
                        </div>
                        <label class="col-md-1 col-form-label">商品名称</label>
                        <div class="col-md-2">
                          <input type="text" class="form-control" placeholder="商品名称" v-model="goodsName">
                        </div>
                        <div class="col-md-1">
                          <a class="btn btn-primary ButtonColor m-r-5" @click="SearchClick()">查询</a>
                        </div>
                      </div>
                    </fieldset>
                  </form>
                  <el-table :data="purchaseDetail" border style="width: 100%">
                    <el-table-column prop="ordernumber" label="序号" width="60" align="center"></el-table-column>
                    <el-table-column prop="brandName" label="品牌" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="seriesName" label="系列" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="goodsName" label="商品名称" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="outCount" label="出库数量" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="operator" label="出库人" align="center" show-overflow-tooltip></el-table-column>
                    <el-table-column prop="inputTime" label="出库时间" align="center" show-overflow-tooltip></el-table-column>
                  </el-table>
                  <div class="PaginationStyle">
                    <el-pagination
                      @size-change="handleSizeChange"
                      @current-change="handleCurrentChange"
                      :current-page="pageindex"
                      :page-sizes="[10,20,50,100]"
                      :page-size="pageSize"
                      layout="total, sizes, prev, pager, next, jumper"
                      background
                      :total="totalCount"
                    ></el-pagination>
                  </div>
                  <div style="text-align:right;margin-top:15px;">
                    <a class="btn btn-primary ButtonColor m-r-5" @click="Goback">返 回</a>
                  </div>
                </div>
                <!-- end panel-body -->
              </div>
              <!-- end panel -->
            </div>
            <!-- end col-10 -->
          </div>
          <!-- end row -->
        </div>
        <!-- end #content -->
      </div>
    </div>
  </div>
  
</template>

<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
export default {
  name: "PurchaseOrderDetail",
  data() {
    return {
      pageSize: 10,
      totalCount: 0,
      pageindex: 1,
      director:0,
      outId:'',
      purchaseDetail:[],
      BrandOptions: [],
      SeriesOptions: [],
      brandId: "",
      seriesId: "",
      goodsName:"",
      checkId:""
    };
  },
  mounted: function() {
    // if(this.$route.query.director){
    //   this.director = this.$route.query.director;
    // }
    if(this.$route.query.outId){
      this.outId = this.$route.query.outId;
    }
    if(this.$route.query.checkId){
      this.checkId = this.$route.query.checkId;
    }
    this.initdata();
    this.getBrandInfo();
  },
  methods: {
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageindex = 1;
      this.initdata();
    },
    handleCurrentChange(val) {
      this.pageindex = val;
      this.initdata();
    },
    SearchClick() {
      this.pageindex = 1;
      this.initdata();
    },
    getBrandInfo() {
      let that = this;
      const options = {
        url: "distribution/B2cGoodsInfoController/cascadeQuery",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        data: Qs.stringify({})
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            that.BrandOptions = response.data.data.brandList;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    BrandChange(val) {
      if(val.length !== 0){
        let that = this;
        const options = {
          url: "distribution/B2cGoodsInfoController/cascadeQuery",
          method: "post",
          headers: { "Content-Type": "application/x-www-form-urlencoded" },
          data: Qs.stringify({
            brandId: that.brandId
          })
        };
        axios(options).then(function(response) {
          if (response.data.code == 200) {
            that.SeriesOptions = response.data.data;
          } else {
            http.handleEorrorCode(response,that);
          }
        })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
      }else{
        this.brandId = '';
        this.seriesId = '';
        this.SeriesOptions = [];
      }
    },
    initdata() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/outGoodsInfo",
        method: "post",
        headers: {
          "Content-Type": "application/x-www-form-urlencoded"
        },
        data: Qs.stringify({
          outId: that.outId,
          brandId: that.brandId,
          seriesId: that.seriesId,
          goodsName: that.goodsName,
          current: that.pageindex,
          size: that.pageSize,
        })
      };
      axios(options).then(response => {
        if (response.data.code == 200) {
          that.purchaseDetail = response.data.data.records;
          that.totalCount = response.data.data.total;
          for (var i in response.data.data.records) {
            response.data.data.records[i].ordernumber =
              Number((that.pageindex - 1) * that.pageSize) + Number(i) + 1;
          }
        } else {
          http.handleHttpError(error, that);
        }
      })
        .catch(function(error) {
          http.handleHttpError(error, that);
        });
    },
    Goback() {
      if(this.checkId == 1){
        this.$router.push({
          path: "outbound"
        });
      }else if(this.checkId == 2){
        this.$router.push({
          path: "outboundreviews"
        });
      }else if(this.checkId == 3){
        this.$router.push({
          path: "outboundlist"
        });
      }
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  text-align: right;
  margin-top: 15px;
}
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.ModelPadding {
  margin-top: -20px;
}
.LineSpacing {
  margin-top: 16px;
}
.InputWidth{
  width:202px;
}
.TitleStyle {
  color: #6a7786;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/OutboundDetail.vue